import { render, staticRenderFns } from "./AddressPopup.vue?vue&type=template&id=22299065&scoped=true"
import script from "./AddressPopup.vue?vue&type=script&lang=ts"
export * from "./AddressPopup.vue?vue&type=script&lang=ts"
import style0 from "./AddressPopup.vue?vue&type=style&index=0&id=22299065&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22299065",
  null
  
)

export default component.exports